import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { DefaultsContext } from 'features/globalSetup/pages/Defaults/DefaultsContext'
import { useGetRichPlacementKWords } from '../../hooks/useGetRichPlacementKWords'
import { useUpdateRichPlacementKWords } from '../../hooks/useUpdateRichPlacementKWords'
import { schema, Schema, schemaDefault } from './schema'
import { KWordsSection } from './Section'

export const KWordsForm = (): React.JSX.Element => {
  const { formId, setTouched, setValid } = useContext(DefaultsContext)
  const { isLoading, kWords } = useGetRichPlacementKWords()

  const { errors, isPending: isUpdating, update } = useUpdateRichPlacementKWords()

  if (!kWords) {
    return <Loading />
  }

  return (
    <Form<Schema>
      externalErrors={errors}
      id={formId}
      loading={isLoading || isUpdating}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(kWords)}
    >
      {() => <KWordsSection />}
    </Form>
  )
}
